import dayjs from "dayjs";
import "dayjs/locale/th";
import { useGlobalContext } from "../../context/provider";
import { AxiosPostData } from "../../context/axiosfunction";
import { message, Modal } from "antd";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
dayjs.locale("th");

const SVGCoupon = ({ data, coupon_user, page, setuser_pone }) => {
  const { API, headers, Token } = useGlobalContext();
  const [messageApi, contextHolder] = message.useMessage();
  const [active, setActive] = useState(false);
  const [description,setDescription] = useState(false)

  const discount = String(data?.cp_discount ?? "");
  const discountLength = discount.length;

  const GetCoupon = async (data) => {
    if (Token) {
      const coupondata = { coupon_id: data?.id };
      const response = await AxiosPostData(API, "/api/get_coupone", coupondata, headers);
      if (response.status === "success") {
        messageApi.open({
          type: "success",
          content: response.message,
        });
        setActive(true);
        setuser_pone((prev) => [...prev, data.id]);
      } else {
        messageApi.open({
          type: "error",
          content: response.message,
        });
      }
    } else {
      messageApi.open({
        type: "warning",
        content: "กรุณาเข้าสู่ระบบก่อนรับคูปอง",
      });
    }
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 361 96"
      className="w-[300px] md:w-[320px] h-auto"
      fill="none"
    >
      <Modal title={data.cp_name} open={description} onCancel={()=>setDescription(false)} footer={null}>
        <div className="rich-html"  dangerouslySetInnerHTML={{__html:data.cp_des}}></div> 
      </Modal>
      {contextHolder}
      <rect width="361" height="96" fill="#F5F5F5" />
      <rect
        x="0.5"
        y="0.5"
        width="360"
        height="95"
        rx="8"
        fill="white"
        stroke="#E5E5E5"
      />
      <image
        href="https://eve-image.eveebook.com/image.eveebook/mascot/reading.png"
        x="130"
        y="0"
        width="230"
        height="96"
        opacity="0.20"
        preserveAspectRatio="xMidYMid slice"
      />
      <path
        d="M0 88C0 92.4183 4.73299 96 10.5714 96H37V57.4141C37 51.9534 31.8669 47.2651 24.7768 46.25C17.6867 45.2349 12.5536 40.5466 12.5536 35.0859V0H10.5714C4.73299 0 0 3.58173 0 8V88Z"
        fill="black"
      />
      <image
        href="https://eve-image.eveebook.com/image.eveebook/web_image/EVELogoWhite.png"
        x="-15"
        y="18"
        width="34"
        height="52"
        preserveAspectRatio="xMidYMid meet"
        transform="rotate(-90 25 48)"
      />
      {data.cp_des &&
      <foreignObject x="330" y="5" width="20" height="20">
        <button onClick={()=>setDescription(true)} >
          {/* <Tooltip placement="right" title={ <span dangerouslySetInnerHTML={{__html:data.cp_des}}></span> }> */}
            <FontAwesomeIcon
              icon={faCircleInfo}
              style={{
                color: "#555",
                fontSize: "16px",
                cursor: "pointer",
              }}
            />
          {/* </Tooltip> */}
        </button>
      </foreignObject>
      }
      
      <text x="25" y="22" fill="black" fontSize="16" fontWeight="normal">
        {data.cp_name}
      </text>
      <text x="50" y="55" fill="black" fontSize="20" fontWeight="normal">
        ลด
      </text>

      <text x="80" y="55" fill="#FF347F" fontSize="30" fontWeight="bold">
        {data?.cp_discount}
      </text>

      {data?.cp_code_type === "percent" ? (
        <text
          x={discountLength === 2 ? "130" : "150"}
          y="55"
          fill="black"
          fontSize="24"
          fontWeight="bold"
        >
          %
        </text>
      ) : (
        <image
          href="https://eve-image.eveebook.com/image.eveebook/web_image/coin.png"
          x={discountLength === 2 ? "130" : "150"}
          y="30"
          width="28"
          height="28"
          preserveAspectRatio="xMidYMid meet"
        />
      )}

      {data?.cp_min_spend && (
        <text x="50" y="75" fill="black" fontSize="14">
          ชำระขั้นต่ำ {data?.cp_min_spend} เหรียญ
        </text>
      )}

      {data?.cp_end && (
        <text x="50" y="90" fill="black" fontSize="12">
          หมดอายุ {dayjs(data?.cp_end).format("DD MMM YYYY")}
        </text>
      )}

      {page === "main" && (
        <foreignObject x="255" y="50" width="90" height="40">
          {(coupon_user?.includes(data?.id) || active) ? (
            <button
              disabled
              xmlns="http://www.w3.org/1999/xhtml"
              style={{
                width: "100%",
                height: "100%",
                background: "#CCCCCC",
                color: "white",
                border: "none",
                borderRadius: "6px",
                fontSize: "14px",
                cursor: "not-allowed",
              }}
            >
              รับแล้ว
            </button>
          ) : (
            <button
              xmlns="http://www.w3.org/1999/xhtml"
              style={{
                width: "100%",
                height: "100%",
                background: "#f43f5e",
                color: "white",
                border: "none",
                borderRadius: "6px",
                fontSize: "14px",
                cursor: "pointer",
              }}
              onClick={() => GetCoupon(data)}
            >
              รับคูปอง
            </button>
          )}
        </foreignObject>
      )}
    </svg>
  );
};

export default SVGCoupon;
